<script lang="ts">
  import { round } from "@/Util/utils";
    import { ProgramAchievabilityStatusIcon } from "..";
    import type {RaceAchievability} from "../../modules/ProgramAchievability"
  import { Separator } from "@/lib/components/ui/separator";
    type $$Props = RaceAchievability["event_readiness"] & {
        event_readiness_target: number
    }
    export let status: $$Props["status"]
    export let low_er_achievable: $$Props["low_er_achievable"]                
    export let high_er_achievable: $$Props["high_er_achievable"]
    export let peak_er_achievable: $$Props["peak_er_achievable"]
    export let event_readiness_target: $$Props["event_readiness_target"]
</script>
<div class="text-sm text-slate-500">
    {#if status === "fine"}
    <div class="text-slate-600">Event Readiness Level <span class="font-medium">{event_readiness_target}</span><wbr> can be achieved.</div>
    <Separator class="mb-1"/>
    <div>Best Low: {round(low_er_achievable, 1)}</div>
    <div>Best High: {round(high_er_achievable, 1)}</div>
    <div>Best Peak: {round(peak_er_achievable, 1)}</div>
    {:else}
    <div class="text-slate-600">Event Readiness Level <span class="font-medium">{event_readiness_target}</span><wbr> cannot be achieved.</div>
    <Separator class="mb-1"/>
    <div>Best Low: {round(low_er_achievable, 1)} <ProgramAchievabilityStatusIcon status={low_er_achievable > event_readiness_target ? "error" : "fine"}/></div>
    <div>Best High: {round(high_er_achievable, 1)} <ProgramAchievabilityStatusIcon status={high_er_achievable > event_readiness_target ? "error" : "fine"}/></div>
    <div>Best Peak: {round(peak_er_achievable, 1)} <ProgramAchievabilityStatusIcon status={peak_er_achievable > event_readiness_target ? "error" : "fine"}/></div>
    {/if}
</div>